import captureException from '../../utils/captureException';
import { sortComments } from '../../utils/comments';
import { isDataOutdated } from '../../utils/helpers';
import { DELETE_STORE_COMMENT, SET_COMMENTS, SET_COMMENTS_LOADING, SET_MENTION_OWNERS, SET_NEW_COMMENT, UPDATE_STORE_COMMENT } from './reducer';
export const getComments = ({
  dispatch,
  postponeWithAppLoader,
  apiWrapper
}, {
  callObjectId,
  isLoading,
  isPostponedAction,
  setSkipRefresh,
  storeComments
}) => {
  dispatch({
    type: SET_COMMENTS_LOADING,
    payload: isLoading
  });
  apiWrapper.getComments({
    callObjectId,
    setSkipRefresh
  }).then(response => {
    if (isDataOutdated(response.results, storeComments) && isPostponedAction && postponeWithAppLoader) {
      postponeWithAppLoader(() => {
        dispatch({
          type: SET_COMMENTS,
          payload: sortComments(response.results)
        });
      });
    } else if (!isPostponedAction) {
      dispatch({
        type: SET_COMMENTS,
        payload: sortComments(response.results)
      });
    }
  }).catch(error => {
    captureException(error);
    dispatch({
      type: SET_COMMENTS_LOADING,
      payload: false
    });
  });
};
export const createNewComment = ({
  dispatch,
  apiWrapper
}, payload) => {
  dispatch({
    type: SET_COMMENTS_LOADING,
    payload: true
  });
  apiWrapper.createComment(payload).then(response => {
    dispatch({
      type: SET_NEW_COMMENT,
      payload: response
    });
  }).catch(error => {
    captureException(error);
    dispatch({
      type: SET_COMMENTS_LOADING,
      payload: false
    });
  });
};
export const deleteExistingComment = ({
  dispatch,
  apiWrapper
}, commentId) => {
  dispatch({
    type: SET_COMMENTS_LOADING,
    payload: true
  });
  apiWrapper.deleteComment(commentId).then(() => {
    dispatch({
      type: DELETE_STORE_COMMENT,
      payload: commentId
    });
  }).catch(error => {
    captureException(error);
    dispatch({
      type: SET_COMMENTS_LOADING,
      payload: false
    });
  });
};
export const updateExistingComment = ({
  dispatch,
  apiWrapper
}, payload) => {
  dispatch({
    type: SET_COMMENTS_LOADING,
    payload: true
  });
  apiWrapper.updateComment(payload).then(response => {
    dispatch({
      type: UPDATE_STORE_COMMENT,
      payload: response
    });
  }).catch(error => {
    captureException(error);
    dispatch({
      type: SET_COMMENTS_LOADING,
      payload: false
    });
  });
};
export const fetchOwners = ({
  apiWrapper,
  dispatch
}) => {
  const payload = {
    query: '',
    referenceType: 'OWNER',
    offset: 0,
    limit: 50,
    crmObjectType: 'contact'
  };
  apiWrapper.fetchOwners(payload).then(response => {
    const parsedOwners = response.results.map(owner => ({
      value: +owner.id,
      searchText: `${owner.label} (${owner.description})`,
      dropdownText: `${owner.label} (${owner.description})`,
      text: owner.label,
      userId: owner.additionalFields.activeUserId
    }));
    dispatch({
      type: SET_MENTION_OWNERS,
      payload: parsedOwners
    });
  }).catch(captureException);
};